  <!-- Steps -->
  <div class="py-2 px-4 max-h-[60vh] overflow-auto">
      <!-- Quote options section -->
      <ng-container *ngIf="quotes && !isClient">
        <div class="space-y-4">
          <ng-container *ngFor="let quote of getReservedQuotes(); let last = last; trackBy: trackByFn">
            <ng-container *ngTemplateOutlet="quoteItem; context: {$implicit: quote, last: last}"></ng-container>
          </ng-container>
          <div *ngIf="getReservedQuotes().length > 0 && getRegularQuotes().length > 0" class="py-4">
            <div class="flex items-center">
              <div class="flex-grow border-t border-gray-300"></div>
              <span class="flex-shrink mx-4 text-gray-500 text-sm font-medium">Other Options</span>
              <div class="flex-grow border-t border-gray-300"></div>
            </div>
          </div>
          <ng-container *ngFor="let quote of getRegularQuotes(); let last = last; trackBy: trackByFn">
            <ng-container *ngTemplateOutlet="quoteItem; context: {$implicit: quote, last: last}"></ng-container>
          </ng-container>
        </div>
      </ng-container>
      
      <ng-container *ngIf="quotes && quotes.content && isReviewDrawerVisible && !isClient">
        <div class="flex flex-row justify-center items-center w-full">
          <hr class="border-b mx-4 sm:mx-4 mt-2 mb-3 w-full">
        </div>

        <div class="flex flex-row justify-end items-center gap-x-2">
          <a class="option-icon-button" target="_blank" href="{{quotes._links[0].href}}/documents/pdf/list?{{view.quotesAll}}" matTooltip="Download All quotes"><mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:arrow-down-on-square-stack'"></mat-icon></a>
          <a *ngIf="view.quotesSelected" [disabled]="!view.quotesSelected" class="option-icon-button" target="_blank" href="{{quotes._links[0].href}}/documents/pdf/list?{{view.quotesSelected}}" matTooltip="Download Selected quotes"><mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:arrow-down-on-square'"></mat-icon></a>
        </div>
      </ng-container>
      <!-- <div *ngIf="itin_view?.quotes">
            <div *ngFor="let cartItem of itin_view?.quotes.content">
                <span>{{cartItem.itinerary.destinationHotel}}</span> | <span> {{cartItem.itinerary.total}}</span> | <a target="_blank" href="{{itin_view?.quotes._links[0].href}}/{{cartItem.itinerary.guid}}/documents/pdf/ss">Download</a>
            </div>
            <br><br>
            <a target="_blank" href="{{itin_view?.quotes._links[0].href}}/documents/pdf/sslist?{{this.queryStringGuid}}">Download All</a>

          </div> -->

      <ol>
        <ng-container>
          @for (item of view.cart; track $index) {
            <div class="flex flex-row w-full">
              <mat-icon *ngIf="item.type == 'flight'" class="icon-size-5 text-hint mr-2 mt-1" [svgIcon]="'mat_outline:flight_takeoff'"></mat-icon>
              <mat-icon *ngIf="item.type == 'hotel'" class="icon-size-5 text-hint mr-2 mt-1" [svgIcon]="'heroicons_outline:home-modern'"></mat-icon>
              <mat-icon *ngIf="item.type == 'car'" class="icon-size-5 text-hint mr-2 mt-1" [svgIcon]="'mat_outline:car_rental'"></mat-icon>
              <mat-icon *ngIf="item.type == 'transfer'" class="icon-size-5 text-hint mr-2 mt-1" [svgIcon]="'mat_outline:airport_shuttle'"></mat-icon>
              <mat-icon *ngIf="item.type == 'activity'" class="icon-size-5 text-hint mr-2 mt-1" [svgIcon]="'mat_outline:beach_access'"></mat-icon>
              <div [ngClass]="{'basis-5/12': isReviewDrawerVisible, 'basis-12/12': !isReviewDrawerVisible}" class="font-small text-hint flex flex-col">
                {{isReviewDrawerVisible ? item.title : item.titleShort}}
                @if (isReviewDrawerVisible && item.departDate && item.arriveDate) {
                <span class="text-hint text-sm -mt-2">{{item.departDate | date : 'dd MMM yy HH:mm'}} - {{item.arriveDate | date : 'dd MMM yy HH:mm'}}</span>
                }
                @if (isReviewDrawerVisible && isFlightItem(item) && getFareSource(item)) {
                <span class="text-hint text-xs -mt-1">Fare source: {{getFareSource(item)}}</span>
                }
                @if (item.type == 'hotel') {
                  @for (room of item.item.rooms; track $index) {
                    @if (room.selected) {
                      <span class="text-hint text-sm -mt-2"><b>Room {{room.rph}}</b> {{room.name}}</span>
                    }
                  }
                }
              </div>
              <div>

              </div>
              <div *ngIf="isReviewDrawerVisible" [ngClass]="{'basis-2/12': isReviewDrawerVisible, '': !isReviewDrawerVisible}" class="font-small text-hint">{{item.duration}}</div>
              <div *ngIf="isReviewDrawerVisible" [ngClass]="{'basis-2/12': isReviewDrawerVisible, '': !isReviewDrawerVisible}" class="font-small text-hint">{{item.pax.total}} {{item.pax.total == 1 ? 'Person' : 'People'}}</div>
              <div *ngIf="isReviewDrawerVisible && !isClient" [ngClass]="{'basis-2/12': isReviewDrawerVisible, '': !isReviewDrawerVisible}" class="font-medium leading-6 text-primary dark:text-primary-500 text-right">{{item.price | currency:displayCurrencyCode:'symbol-narrow'}}</div>

              <!-- <div *ngIf="isReviewDrawerVisible" [ngClass]="{'basis-1/12': isReviewDrawerVisible, '': !isReviewDrawerVisible}">
                <button matTooltip="Remove service" mat-icon-button (click)="removeItem(item)" [tabIndex]="-1" class="-mt-2">
                  <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                </button>
              </div> -->
            </div>
          }
        </ng-container>

        <ng-container *ngFor="let point of _view?.trip?.points; let last = last; trackBy: trackByFn">
          <ng-container *ngIf="point.showInCart && (!isClient || (isClient && isReviewDrawerVisible))">
            <ng-container *ngIf="isClient">
            <li class="relative group py-6" [class.current-step]="getItemsFromPoint(point.index).length == 0">
                  <ng-container *ngIf="!last">
                      <div class="absolute top-6 left-4 w-0.5 h-full -ml-px" [ngClass]="{'bg-primary': getItemsFromPoint(point.index).length > 0, 'bg-gray-300 dark:bg-gray-600': getItemsFromPoint(point.index).length == 0}"></div>
                  </ng-container>
                  <div class="relative flex items-start cursor-pointer">
                      <div (click)="goToStep(point.order)" class="flex flex-0 items-center justify-center w-8 h-8 rounded-full ring-2 ring-inset bg-card dark:bg-default"
                          [ngClass]="{'bg-primary dark:bg-accent text-on-primary group-hover:bg-accent-800 ring-transparent': getItemsFromPoint(point.index).length > 0,
                                      'ring-accent': getItemsFromPoint(point.index).length > 0,
                                      'ring-gray-300 dark:ring-gray-600 group-hover:ring-gray-400': getItemsFromPoint(point.index).length == 0}">
                          <!-- Check icon, show if the step is completed -->
                          <ng-container *ngIf="getItemsFromPoint(point.index).length > 0">
                              <mat-icon class="icon-size-5 text-current text-accent-500" [svgIcon]="'heroicons_solid:check'"></mat-icon>
                          </ng-container>
                          <!-- Step order, show if the step is the current step -->
                          <!-- <ng-container *ngIf="getItemsFromPoint(point.index).length > 0">
                              <div class="text-md font-semibold text-primary dark:text-primary-500">{{point.index}}</div>
                          </ng-container> -->
                          <!-- Step order, show if the step is not completed -->
                          <ng-container *ngIf="getItemsFromPoint(point.index).length == 0">
                              <div class="text-md font-semibold text-hint group-hover:text-secondary">{{point.index + 1}}</div>
                          </ng-container>
                      </div>
                      <div class="ml-4 mr-4 w-full">
                          <div class="font-medium leading-4">{{point.title}}</div>
                          <div class="mt-1.5 text-md leading-4 text-secondary">{{point.date | date : 'dd MMM yy'}} <ng-container *ngIf="isReviewDrawerVisible && point.dateTo > 0"> - {{point.dateTo | date : 'dd MMM yy'}}</ng-container></div>
                          
                            @for (item of getItemsFromPoint(point.index); track $index) {
                              <div class="flex flex-row w-full">
                                <mat-icon *ngIf="item.type == 'flight'" class="icon-size-5 text-hint mr-2 mt-1" [svgIcon]="'mat_outline:flight_takeoff'"></mat-icon>
                                <mat-icon *ngIf="item.type == 'hotel'" class="icon-size-5 text-hint mr-2 mt-1" [svgIcon]="'heroicons_outline:home-modern'"></mat-icon>
                                <mat-icon *ngIf="item.type == 'car'" class="icon-size-5 text-hint mr-2 mt-1" [svgIcon]="'mat_outline:car_rental'"></mat-icon>
                                <mat-icon *ngIf="item.type == 'transfer'" class="icon-size-5 text-hint mr-2 mt-1" [svgIcon]="'mat_outline:airport_shuttle'"></mat-icon>
                                <mat-icon *ngIf="item.type == 'activity'" class="icon-size-5 text-hint mr-2 mt-1" [svgIcon]="'mat_outline:beach_access'"></mat-icon>
                                <div [ngClass]="{'basis-5/12': isReviewDrawerVisible, 'basis-12/12': !isReviewDrawerVisible}" class="font-small text-hint flex flex-col">
                                  {{isReviewDrawerVisible ? item.title : item.titleShort}}
                                  @if (isReviewDrawerVisible && item.departDate && item.arriveDate) {
                                  <span class="text-hint text-sm -mt-2">{{item.departDate | date : 'dd MMM yy HH:mm'}} - {{item.arriveDate | date : 'dd MMM yy HH:mm'}}</span>
                                  }
                                  @if (isReviewDrawerVisible && isFlightItem(item) && getFareSource(item)) {
                                  <span class="text-hint text-xs -mt-1">Fare source: {{getFareSource(item)}}</span>
                                  }
                                  @if (item.type == 'hotel') {
                                    @for (room of item.item.rooms; track $index) {
                                      @if (room.selected) {
                                        <span class="text-hint text-sm -mt-2"><b>Room {{room.rph}}</b> {{room.name}}</span>
                                      }
                                    }
                                  }
                                </div>
                                <div>

                                </div>
                                <div *ngIf="isReviewDrawerVisible" [ngClass]="{'basis-2/12': isReviewDrawerVisible, '': !isReviewDrawerVisible}" class="font-small text-hint">{{item.duration}}</div>
                                <div *ngIf="isReviewDrawerVisible" [ngClass]="{'basis-2/12': isReviewDrawerVisible, '': !isReviewDrawerVisible}" class="font-small text-hint">{{item.pax.total}} {{item.pax.total == 1 ? 'Person' : 'People'}}</div>
                                <div *ngIf="isReviewDrawerVisible" [ngClass]="{'basis-2/12': isReviewDrawerVisible, '': !isReviewDrawerVisible}" class="font-medium leading-6 text-primary dark:text-primary-500 text-right">{{item.price | currency:displayCurrencyCode:'symbol-narrow'}}</div>

                                <div *ngIf="isReviewDrawerVisible" [ngClass]="{'basis-1/12': isReviewDrawerVisible, '': !isReviewDrawerVisible}">
                                  <button matTooltip="Remove service" mat-icon-button (click)="removeItem(item)" [tabIndex]="-1" class="-mt-2">
                                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                                  </button>
                                </div>
                              </div>
                            }
                        
                            @if (point.type == 'airport') {
                              <a *ngIf="_view?.trip.points.length > (point.index + 1) && point.index < _view?.trip.points.length && !_view?.hasIncludedTransfers" href="javascript:void(0)" (click)="searchService(getPointFromIndex(point.index + 1), 'transfer')">
                                <div class="flex flex-row items-center justify-center w-56 rounded-lg cursor-pointer border-2 border-gray-300 border-dashed hover:bg-hover transition-colors duration-150 ease-in-out mt-1.5 text-md leading-4 text-secondary">
                                  <mat-icon class="icon-size-5 text-hint mr-1" [svgIcon]="'mat_outline:airport_shuttle'"></mat-icon> Add transfer
                                  <br/>
                                </div>
                              </a>
                              <div *ngIf="_view?.trip.points.length > (point.index + 1) && point.index < _view?.trip.points.length && _view?.hasIncludedFlights" class="flex flex-row items-center justify-center w-56 rounded-lg cursor-pointer border-2 border-gray-300 border-dashed transition-colors duration-150 ease-in-out mt-1.5 text-md leading-4 text-secondary bg-green-300">
                                <mat-icon class="icon-size-5 text-hint mr-1" [svgIcon]="'mat_outline:flight_takeoff'"></mat-icon> Include flights
                                <br/>
                              </div>
                              <div *ngIf="_view?.trip.points.length > (point.index + 1) && point.index < _view?.trip.points.length && _view?.hasIncludedTransfers" class="flex flex-row items-center justify-center w-56 rounded-lg cursor-pointer border-2 border-gray-300 border-dashed transition-colors duration-150 ease-in-out mt-1.5 text-md leading-4 text-secondary bg-green-300">
                                <mat-icon class="icon-size-5 text-hint mr-1" [svgIcon]="'mat_outline:airport_shuttle'"></mat-icon> Include transfers
                                <br/>
                              </div>
                            }
                            @if (point.type == 'hotel') {
                              <a *ngIf="point.dateTo" href="javascript:void(0)" (click)="searchService(point, 'activity')">
                                <div class="flex flex-row items-center justify-center w-56 rounded-lg cursor-pointer border-2 border-gray-300 border-dashed hover:bg-hover transition-colors duration-150 ease-in-out mt-1.5 text-md leading-4 text-secondary">
                                  <mat-icon class="icon-size-5 text-hint mr-1" [svgIcon]="'mat_outline:beach_access'"></mat-icon> Add activity
                                  <br/>
                                </div>
                              </a>
                              <a *ngIf="_view?.trip.points.length > (point.index + 1) && point.index < _view?.trip.points.length && !view?.hasIncludedTransfers" href="javascript:void(0)" (click)="searchService(point, 'transfer')">
                                <div class="flex flex-row items-center justify-center w-56 rounded-lg cursor-pointer border-2 border-gray-300 border-dashed hover:bg-hover transition-colors duration-150 ease-in-out mt-1.5 text-md leading-4 text-secondary">
                                  <mat-icon class="icon-size-5 text-hint mr-1" [svgIcon]="'mat_outline:airport_shuttle'"></mat-icon> Add transfer
                                  <br/>
                                </div>
                              </a>
                              <div *ngIf="_view.hasIncludedTransfers" class="flex flex-row items-center justify-center w-56 rounded-lg cursor-pointer border-2 border-gray-300 border-dashed transition-colors duration-150 ease-in-out mt-1.5 text-md leading-4 text-secondary bg-green-300">
                                <mat-icon class="icon-size-5 text-hint mr-1" [svgIcon]="'mat_outline:airport_shuttle'"></mat-icon> Include transfers
                                <br/>
                              </div>
                              <div *ngIf="_view.hasIncludedFlights" class="flex flex-row items-center justify-center w-56 rounded-lg cursor-pointer border-2 border-gray-300 border-dashed transition-colors duration-150 ease-in-out mt-1.5 text-md leading-4 text-secondary bg-green-300">
                                <mat-icon class="icon-size-5 text-hint mr-1" [svgIcon]="'mat_outline:flight_takeoff'"></mat-icon> Include flights
                                <br/>
                              </div>
                            }
                      </div>
                  </div>
              </li>
          </ng-container>
          </ng-container>
        </ng-container>
      </ol>
  </div>

  <div class="flex flex-row mt-5 border-t pl-10 pr-10 w-full justify-center" *ngIf="isReviewDrawerVisible">
      <div class="flex px-8 py-5 cursor-pointer hidden">
        <a href="javascript:void(0)" (click)="searchService(null, 'activity')">
          <!-- <mat-icon [svgIcon]="'mat_outline:save'"></mat-icon> -->
          <div class="ml-3">
              <div class="font-medium leading-6">Add activities</div>
          </div>
        </a>
      </div>
      <div class="flex px-8 py-5 cursor-pointer hidden">
        <a href="javascript:void(0)" (click)="searchService(null, 'transfer')">
          <!-- <mat-icon [svgIcon]="'mat_outline:save'"></mat-icon> -->
          <div class="ml-3">
              <div class="font-medium leading-6">Add transfers</div>
          </div>
        </a>
      </div>
      <div class="flex px-8 py-5 cursor-pointer hidden" *ngIf="itin && itin.content && itin.content.itinerary && !isClient">
        <a href="javascript:void(0)" (click)="validateQuote('view-quote')">
          <!-- <mat-icon [svgIcon]="'mat_outline:save'"></mat-icon> -->
          <div class="ml-3">
              <div class="font-medium leading-6">View Quote {{itin.content.itinerary.reference}}</div>
          </div>
        </a>
      </div>
      <div class="flex px-8 py-5 cursor-pointer hidden">
        <a href="javascript:void(0)" (click)="clearCart()">
          <!-- <mat-icon [svgIcon]="'mat_outline:save'"></mat-icon> -->
          <div class="ml-3">
              <div class="font-medium leading-6">Clear cart</div>
          </div>
        </a>
      </div>
  </div>
  <div class="flex flex-row mt-10 border-t pl-10 pr-10 w-full justify-center hidden" *ngIf="isReviewDrawerVisible">

    <div class="flex px-8 py-5 cursor-pointer">
        <mat-icon [svgIcon]="'mat_outline:save'"></mat-icon>
        <div class="ml-3">
            <div class="font-medium leading-6">Save as idea</div>
        </div>
    </div>

    <div class="flex px-8 py-5 cursor-pointer">
      <mat-icon [svgIcon]="'mat_outline:share'"></mat-icon>
      <div class="ml-3">
          <div class="font-medium leading-6">Share</div>
      </div>
    </div>

    <div class="flex px-8 py-5 cursor-pointer">
      <mat-icon [svgIcon]="'mat_outline:file_download'"></mat-icon>
      <div class="ml-3">
          <div class="font-medium leading-6">Download</div>
      </div>
    </div>
  </div>
  <ng-template #modalPayment let-modal>
    <!-- LARGE MODAL -->
    <div class="modal-header">
      <h6 class="modal-title">Payments <br /><small>Itinerary reference 12345</small></h6>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" style="padding:0px;overflow-x: hidden;">
      <div class="row">
        <div class="col-sm-6 col-md-6" style="padding:1em;">
          <div class="row">
            <div class="col-md-12 text-center mt-3 mb-1">
              <h6>Previously recorded payments</h6>
            </div>
          </div>
          <div class="row mt-2 pl-2 pr-2">
            <div class="col-sm-6 col-md-4" ngbTooltip="REF123">Payment 1 <sup class="badge badge-info">1</sup></div>
            <div class="col-sm-6 col-md-3">1000.00 {{displayCurrencyCode}} <sup class="badge badge-info">Credit Card</sup></div>
            <div class="col-sm-6 col-md-3">2023-10-01 <sup class="badge badge-success">Completed</sup></div>
            <div class="col-sm-6 col-md-2 text-right">
              <button class="btn btn-link m-0 p-0">Remove</button>
            </div>
            <hr />
          </div>
          <div class="row mt-2 pl-2 pr-2">
            <div class="col-sm-6 col-md-4" ngbTooltip="REF456">Payment 2 <sup class="badge badge-info">2</sup></div>
            <div class="col-sm-6 col-md-3">500.00 {{displayCurrencyCode}} <sup class="badge badge-info">EFT</sup></div>
            <div class="col-sm-6 col-md-3">2023-10-05 <sup class="badge badge-danger">Failed</sup></div>
            <div class="col-sm-6 col-md-2 text-right">
              <button class="btn btn-link m-0 p-0">Remove</button>
            </div>
            <hr />
          </div>
        </div>
        <div class="col-sm-6 col-md-6" style="padding:1em;background-color:#f0f4f9">
          <div class="row">
            <div class="col-md-12 text-center mt-3 mb-3">
              <h6>Capture a payment</h6>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6 col-md-6">
              <div class="form-group">
                <label class="form-label">Method</label>
                <select class="form-control">
                  <option value="1">Credit Card</option>
                  <option value="2">EFT</option>
                  <option value="3">Debit Card</option>
                </select>
              </div>
            </div>
            <div class="col-sm-6 col-md-6">
              <div class="form-group">
                <label class="form-label">Date of Payment</label>
                <input type="date" class="form-control" value="2023-10-10">
              </div>
            </div>
            <div class="col-sm-6 col-md-6">
              <div class="form-group">
                <label class="form-label">Amount <sup>in {{displayCurrencyCode}}</sup></label>
                <input type="number" class="form-control" value="1500">
              </div>
            </div>
            <div class="col-sm-6 col-md-6">
              <div class="form-group">
                <label class="form-label">Reference</label>
                <input type="text" class="form-control" value="REF789">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12">
              <div class="form-group">
                <label class="form-label">Description</label>
                <input type="text" class="form-control" value="Payment for services">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-center">
              <button type="button" class="btn btn-primary">Save Payment</button><br />
              <small>Once your payment is saved, you will be able to upload proof of payment (recommended).</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary">Add Another Payment</button>
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
    </div>
  </ng-template>
  <ng-template #quoteItem let-quote let-last="last">
    <div class="option-card">
      <div class="option-row">
        <div class="option-badge" [matTooltip]="'Option ' + quote.itinerary.option">
          <span>{{quote.itinerary.option}}</span>
        </div>
        <div class="option-header">
          <div class="option-title">
            {{getDestinationLabel(quote)}}
            <ng-container *ngIf="quote.showServices">
              <ng-container *ngIf="getRoomTypeLabel(quote) as roomType">
                <span class="text-secondary font-normal ml-2">|</span>
                <button type="button" class="text-secondary font-normal ml-1 hover:underline focus:outline-none focus:underline inline-flex items-center gap-0.5" (click)="openEditMealPlanAndRoomType(quote)" matTooltip="Edit room type and meal plan">
                  {{roomType}}
                  <mat-icon class="icon-size-4 ml-0.5" [svgIcon]="'heroicons_outline:pencil-square'"></mat-icon>
                </button>
              </ng-container>
              <ng-container *ngIf="getMealPlanLabel(quote) as mealPlan">
                <span class="text-secondary font-normal ml-2">|</span>
                <button type="button" class="text-secondary font-normal ml-1 hover:underline focus:outline-none focus:underline inline-flex items-center gap-0.5" (click)="openEditMealPlanAndRoomType(quote)" matTooltip="Edit meal plan and room type">
                  {{mealPlan}}
                  <mat-icon class="icon-size-4 ml-0.5" [svgIcon]="'heroicons_outline:pencil-square'"></mat-icon>
                </button>
              </ng-container>
              <ng-container *ngIf="getQuoteDateRange(quote) as dateRange">
                <span class="text-secondary font-normal ml-2" *ngIf="dateRange.start || dateRange.end">
                  | {{dateRange.start | date:'dd MMM yy'}} - {{dateRange.end | date:'dd MMM yy'}}
                </span>
              </ng-container>
            </ng-container>
          </div>
          <div class="option-actions">
            @if (isReviewDrawerVisible) {
              <div class="option-actions-group">
                @if (displayIcons) {
                  <button (click)="openModal(null, 'activity', quote)" class="option-icon-button" type="button" matTooltip="Add activities">
                    <mat-icon class="icon-size-5" svgIcon="mat_outline:spa"></mat-icon>
                  </button>
                }

                <button (click)="openServiceItemDialog({}, quote.itinerary.guid)" class="option-icon-button" type="button" matTooltip="Add Service Item">
                  <mat-icon class="icon-size-5" svgIcon="mat_outline:add"></mat-icon>
                </button>
                <button type="button" class="option-icon-button" (click)="openAddOption(quote, $event)" matTooltip="Add to quote">
                  <mat-icon class="icon-size-5" svgIcon="mat_outline:playlist_add"></mat-icon>
                </button>
                <button matTooltip="WhatsApp Options" type="button" (click)="viewWhatsApp({ content: quote })" class="option-icon-button">
                  <svg viewBox="0 0 24 24" width="24" height="24" class="icon-size-5">
                    <path fill="currentColor" d="M19.05 4.91A9.816 9.816 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.264 8.264 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.183 8.183 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-2-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07s.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28"/>
                  </svg>
                </button>

                <button (click)="openServiceFeeAdjustmentModal(quote)" class="option-icon-button" type="button" matTooltip="Add fee / Adjustment">
                  <mat-icon class="icon-size-5" svgIcon="mat_outline:new_label"></mat-icon>
                </button>
                @if (displayIcons) {
                  <button (click)="openPaymentModal(quote)" class="option-icon-button" type="button" matTooltip="View / Capture Payment">
                    <mat-icon class="icon-size-5" svgIcon="mat_outline:payments"></mat-icon>
                  </button>
                    @if (LoggedInUser?.agentType === 'AGENT' || LoggedInUser?.agentType === 'ADMIN' || LoggedInUser?.agentType === 'MANAGER') {
                    <button matTooltip="View Invoice" type="button" (click)="viewInvoice({content:quote})" [tabIndex]="-1" class="option-icon-button">
                      <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:receipt_long'"></mat-icon>
                    </button>
                  }
                }

                @if (showViewAllPax) {
                  <button (click)="openPaxDetailsModal(quote)" class="option-icon-button option-icon-button--badge" type="button" matTooltip="View All Pax" [disabled]="!hasCapturedPax(quote)">
                    <span *ngIf="getPaxCount(quote) as paxCount" class="option-icon-badge">{{paxCount}}</span>
                    <mat-icon class="icon-size-5" svgIcon="mat_outline:people_outline"></mat-icon>
                  </button>
                }
                <!-- <div class="option-status">
                  <mat-icon class="icon-size-4" [class.text-primary-500]="quote.itinerary.status == 2" [class.text-yellow-500]="quote.itinerary.status == 3" [class.text-green-500]="quote.itinerary.status == 4" [class.text-red-500]="quote.itinerary.status == 5">
                    {{ quote.itinerary.status == 2 ? 'hourglass_empty' : quote.itinerary.status == 3 ? 'pending' : quote.itinerary.status == 4 ? 'check_circle' : 'error' }}
                  </mat-icon>
                </div> -->
                @if (displayIcons) {
                  @if (quote.itinerary.status < 3) {
                    <button matTooltip="Capture pax details before temporary holding services" color="primary" class="option-icon-button option-icon-button--wide" (click)="openReserveModal(quote)">
                      <mat-icon class="icon-size-4 text-primary-500" svgIcon="mat_outline:bookmark_add"></mat-icon>
                      <span class="option-icon-label">Reserve</span>
                    </button>
                  }
                }
              </div>
            }

            <div class="option-actions-group option-actions-group--secondary">
              @if (isReviewDrawerVisible) {
              <button matTooltip="View Quote" type="button" (click)="viewQuote({content:quote})" [tabIndex]="-1" class="option-icon-button">
                <mat-icon class="icon-size-5" [svgIcon]="'feather:eye'"></mat-icon>
              </button>
                <a matTooltip="Download Quote" href="{{quote.itinerary._links[0].href}}/documents/pdf" [tabIndex]="-1" class="option-icon-button">
                  <mat-icon class="icon-size-5" [svgIcon]="'feather:download'"></mat-icon>
                </a>
                <mat-checkbox matTooltip="Select Quote" class="option-checkbox" [color]="'primary'" (change)="selectQuote($event.checked, quote)"></mat-checkbox>
                @if (quote.itinerary.status == 3 && (LoggedInUser.agentType == 'AGENT' || LoggedInUser.agentType == 'ADMIN')) {
                  <button matTooltip="Confirm all itinerary services" mat-button color="primary" class="option-pill-button" (click)="openBookModal(quote)">
                    <mat-icon class="icon-size-5 mx-2">check_circle</mat-icon>
                    Book Now
                  </button>
                  <button matTooltip="Un-reserve currently held services" mat-button color="warn" class="option-pill-button" (click)="openUnReservemodal(quote.itinerary.guid)">
                    <mat-icon class="icon-size-4 px-2">bookmark_remove</mat-icon>
                    Un-Reserve
                  </button>
                }
                <button type="button" (click)="quote.showServices = !quote.showServices" [tabIndex]="-1" class="option-icon-button">
                  <mat-icon class="icon-size-5" [svgIcon]="quote.showServices ? 'heroicons_outline:chevron-up' : 'heroicons_outline:chevron-down'"></mat-icon>
                </button>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="option-meta">
        <div class="option-meta-row">
          <div class="option-meta-item">{{quote.itinerary.reference}}</div>
          @if (isReviewDrawerVisible) {
            <div class="option-meta-item" matTooltip="Quote total">{{quote.itinerary.total | currency : displayCurrencyCode:'symbol-narrow'}}</div>
            <div class="option-meta-item" matTooltip="Paid">
              <mat-icon class="icon-size-4 mr-1">payments</mat-icon>
              {{(quote.itinerary.paid || 0) | currency : displayCurrencyCode:'symbol-narrow'}}
            </div>
            <div class="option-meta-item" matTooltip="Balance">
              <mat-icon class="icon-size-4 mr-1">account_balance_wallet</mat-icon>
              {{(quote.itinerary.balanceCurrent ?? quote.itinerary.balance || 0) | currency : displayCurrencyCode:'symbol-narrow'}}
            </div>
            @if ((LoggedInUser.agentType === 'AGENT' || LoggedInUser.agentType === 'CONSULTANT' || LoggedInUser.agentType === 'ADMIN') && quote.itinerary.commission) {
              <div class="option-meta-item" matTooltip="Agent commission">
                <mat-icon class="icon-size-4 mr-1">badge</mat-icon>
                {{quote.itinerary.commission | currency : displayCurrencyCode:'symbol-narrow'}}
              </div>
            }
            @if (shouldShowStatusChip(quote.itinerary.status)) {
              <span class="bg-green-100 text-green-800 px-3 py-1.5 rounded-full text-sm font-medium capitalize">
                {{getStatusLabel(quote.itinerary.status)}}
              </span>
            }
            <div class="option-meta-item" matTooltip="Quote pax">
              <mat-icon class="icon-size-4 mr-1">people</mat-icon>
              {{quote.itinerary.pax}}
            </div>
            <div class="option-meta-item option-meta-item--value-adds" matTooltip="expand quote to view">
              <mat-icon class="icon-size-4 mr-1">card_giftcard</mat-icon>
              {{getValueAddsCount(quote)}} value add{{getValueAddsCount(quote) !== 1 ? 's' : ''}}
            </div>
            @if (getDiscountsCount(quote) > 0) {
            <div class="option-meta-item text-purple-600" matTooltip="expand quote to view">
              <mat-icon class="icon-size-4 mr-1">local_offer</mat-icon>
              {{getDiscountsCount(quote)}} discount{{getDiscountsCount(quote) !== 1 ? 's' : ''}}
            </div>
            }
          }
        </div>
      </div>

      @if (quote.items != null && quote.items.content != null && quote.showServices) {
        <div class="bg-white py-3 sm:py-4 mt-2 border-t-2 border-b overflow-x-auto">
          @if (compactColumns) {
          <ng-template #emptyCell>-</ng-template>
            <div class="hidden sm:flex w-full gap-4 px-2 sm:px-4 pb-2 text-xs font-semibold tracking-wide text-gray-500 uppercase border-b border-gray-200">
              <div class="w-32">Supplier</div>
              <div class="w-40 min-w-[160px]">Service</div>
              <div class="w-20">Meal plan</div>
              <div class="w-36">Dates</div>
              <div class="w-24 text-center text-amber-500" matTooltip="ROE as of today (current rate)">Sell</div>
            </div>
            @for (item of getServiceItems(quote); track $index) {
              <div class="relative flex cursor-pointer ml-2 sm:ml-4 mt-2" [ngClass]="{'bg-gray-100': $index % 2 === 1}">
                <div class="flex flex-col sm:flex-row sm:items-center w-full gap-2 sm:gap-4 text-xs">
                  <div class="w-full sm:w-32 text-left min-w-0 overflow-visible">
                    <div>{{isAdjustmentItem(item) ? getAdjustmentSupplierLabel(item) : (item.supplier || '-')}}</div>
                    <span *ngIf="getProvidersLabel(item) as provider"
                          [matTooltip]="provider"
                          class="inline-flex mt-1 px-2 py-0.5 rounded-full text-[10px] font-semibold text-primary max-w-full truncate relative z-10">
                      {{provider}}
                    </span>
                    <span *ngIf="!isTransferItem(item) && getCodeLabel(item) as code"
                          [matTooltip]="code"
                          class="inline-flex mt-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-accent text-white max-w-full truncate relative z-10">
                      {{code}}
                    </span>
                  </div>
                  <div class="w-full sm:w-40 sm:min-w-[160px] text-left whitespace-normal break-words">
                    @if (isAdjustmentItem(item)) {
                      {{getAdjustmentServiceLabel(item)}}
                    }
                    @if (!isAdjustmentItem(item)) {
                      {{getServiceLabel(item) || '-'}}
                      <br/>
                      <span class="text-green-500" *ngIf="item.confirmationCode">{{item.confirmationCode}}</span>
                      @if (getBookingCode(item)) {
                      <br/><span class="text-blue-500 text-xs">Booking: {{getBookingCode(item)}}</span>
                      }
                      @if (isFlightItem(item) && getFareSource(item)) {
                      <br/>
                      <span class="text-hint text-xs">Fare source: {{getFareSource(item)}}</span>
                      }
                      @if (getItemValueAdds(item).length > 0) {
                      <div class="mt-1">
                        <div class="text-[11px] leading-4 text-gray-700 font-medium">Included:</div>
                        <ul class="mt-0.5 list-disc pl-4 space-y-0.5">
                        @for (valueAdd of getItemValueAdds(item); track valueAdd; let i = $index) {
                          <li class="text-[11px] leading-4 text-red-600 animate-pulse">
                            <span [innerHTML]="valueAdd"></span>
                            @if (getExtraCodeForValueAdd(item, valueAdd)) {
                              <span class="text-orange-600 font-medium"> ({{getExtraCodeForValueAdd(item, valueAdd)}})</span>
                            }
                          </li>
                        }
                        </ul>
                      </div>
                      }
                      @if (getItemDiscountReasons(item).length > 0) {
                      <div class="mt-1 space-y-0.5">
                        @for (reason of getItemDiscountReasons(item); track reason; let i = $index) {
                          <div class="text-[11px] leading-4 text-purple-600">
                            <span [innerHTML]="reason"></span>
                            @if (getDiscountOfferCode(item, reason)) {
                              <span class="font-medium"> ({{getDiscountOfferCode(item, reason)}})</span>
                            }
                          </div>
                        }
                      </div>
                      }
                    }
                  </div>
                  <div class="w-full sm:w-20 text-left">
                    <ng-container *ngIf="isAccommodationRow(item); else emptyCell">{{getMealPlanLabelForItem(item) || '-'}}</ng-container>
                  </div>
                  <div class="w-full sm:w-36">
                    <ng-container *ngIf="item.start && item.end; else emptyCell">
                      {{item.start | date : 'dd MMM yy'}} - {{item.end | date : 'dd MMM yy'}}
                    </ng-container>
                  </div>
                  <div class="w-full sm:w-24 text-left sm:text-center text-amber-500">
                    <ng-container *ngIf="item.priceCurrentBeforeDiscount != null || item.priceBeforeDiscount != null || item.price != null; else emptyCell">
                      {{(item.priceCurrentBeforeDiscount != null ? item.priceCurrentBeforeDiscount : (item.priceBeforeDiscount != null ? item.priceBeforeDiscount : item.price)) | currency:displayCurrencyCode:'symbol-narrow'}}
                    </ng-container>
                  </div>
                </div>
              </div>
            }
          @if (getServiceTotals(quote); as totals) {
            <div class="flex w-full gap-2 sm:gap-4 text-xs border-t border-gray-200 mt-3 pt-2 bg-sky-50">
              <div class="w-32 font-semibold text-left">Totals</div>
              <div class="w-40 min-w-[160px]"></div>
              <div class="w-20"></div>
              <div class="w-36"></div>
              <div class="w-24 text-center text-amber-500 font-semibold">{{totals.sellTodayRoe | currency:displayCurrencyCode:'symbol-narrow'}}</div>
            </div>
          }

          <!-- Extras / Specials section (compact view) - supplier and room based -->
          <div class="border-t border-gray-200 mt-3 pt-3 hidden">
            <button type="button" class="flex items-center gap-2 w-full text-left py-2 px-2 rounded hover:bg-gray-50 font-medium text-sm" (click)="quote.showExtras = !quote.showExtras; loadQuoteExtras(quote)">
              <mat-icon class="icon-size-5">{{quote.showExtras ? 'expand_less' : 'expand_more'}}</mat-icon>
              Extras / Specials
              @if (quote.extrasLoaded && hasQuoteExtras(quote)) {
                <span class="bg-blue-100 text-blue-800 text-xs px-2 py-0.5 rounded-full">{{getQuoteExtrasCount(quote)}}</span>
              } @else if (quote.extrasLoadComplete) {
                <span class="text-gray-500 text-xs font-normal">No Extras</span>
              }
            </button>
            @if (false && quote.showExtras && quote.extrasLoaded !== undefined) {
              <div class="overflow-x-auto mt-2 border border-gray-200 rounded-lg">
                @for (supplierGroup of getQuoteExtrasData(quote); track supplierGroup.supplierName) {
                  <div class="p-3 border-b border-gray-100 last:border-b-0">
                    <div class="text-xs font-semibold text-gray-600 mb-2">{{supplierGroup.supplierName}}</div>
                    <table class="w-full text-xs min-w-[1800px]">
                      <thead>
                        <tr class="bg-gray-100">
                          <th class="px-2 py-1.5 text-left">From</th>
                          <th class="px-2 py-1.5 text-left">To</th>
                          <th class="px-2 py-1.5 text-left">Book By</th>
                          <th class="px-2 py-1.5 text-center">Min Stay</th>
                          <th class="px-2 py-1.5 text-center">Max Stay</th>
                          <th class="px-2 py-1.5 text-center">Start After</th>
                          <th class="px-2 py-1.5 text-center">Limit</th>
                          <th class="px-2 py-1.5 text-left">Description</th>
                          <th class="px-2 py-1.5 text-right">Cost Adult</th>
                          <th class="px-2 py-1.5 text-right">Cost Teen</th>
                          <th class="px-2 py-1.5 text-right">Cost Child</th>
                          <th class="px-2 py-1.5 text-right">Cost Infant</th>
                          <th class="px-2 py-1.5 text-center">Cost %</th>
                          <th class="px-2 py-1.5 text-center">Compulsory</th>
                          <th class="px-2 py-1.5 text-left">Rate Type</th>
                          <th class="px-2 py-1.5 text-left">Services</th>
                          <th class="px-2 py-1.5 text-left">Basis</th>
                          <th class="px-2 py-1.5 text-left">Code</th>
                          <th class="px-2 py-1.5 text-center">Apply Markup</th>
                          <th class="px-2 py-1.5 text-center">Combinable</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (extra of supplierGroup.extras; track $index) {
                          <tr class="border-t border-gray-100 hover:bg-gray-50">
                            <td class="px-2 py-1.5">{{extra.startDate | date:'dd MMM yy'}}</td>
                            <td class="px-2 py-1.5">{{extra.endDate | date:'dd MMM yy'}}</td>
                            <td class="px-2 py-1.5">{{extra.bookBy ? (extra.bookBy | date:'dd MMM yy') : '-'}}</td>
                            <td class="px-2 py-1.5 text-center">{{extra.minStay ?? '-'}}</td>
                            <td class="px-2 py-1.5 text-center">{{extra.maxStay ?? '-'}}</td>
                            <td class="px-2 py-1.5 text-center">{{extra.startAfter ?? '-'}}</td>
                            <td class="px-2 py-1.5 text-center">{{extra.limitTo ?? '-'}}</td>
                            <td class="px-2 py-1.5">{{extra.freeText || '-'}}</td>
                            <td class="px-2 py-1.5 text-right">{{(extra.cost ?? 0) | currency:displayCurrencyCode:'symbol-narrow'}}</td>
                            <td class="px-2 py-1.5 text-right">{{(extra.costTeen ?? extra.cost ?? 0) | currency:displayCurrencyCode:'symbol-narrow'}}</td>
                            <td class="px-2 py-1.5 text-right">{{(extra.costChild ?? extra.cost ?? 0) | currency:displayCurrencyCode:'symbol-narrow'}}</td>
                            <td class="px-2 py-1.5 text-right">{{(extra.costInfant ?? extra.cost ?? 0) | currency:displayCurrencyCode:'symbol-narrow'}}</td>
                            <td class="px-2 py-1.5 text-center">{{extra.costPercentage ?? '-'}}</td>
                            <td class="px-2 py-1.5 text-center">{{extra.compulsory ? 'Yes' : 'No'}}</td>
                            <td class="px-2 py-1.5">{{extra.rateType || '-'}}</td>
                            <td class="px-2 py-1.5">{{(extra.selectedServices?.length || extra.serviceIDs?.length) ? ((extra.selectedServices?.length || extra.serviceIDs?.length) + ' service(s)') : '-'}}</td>
                            <td class="px-2 py-1.5">{{extra.basisIDs || (extra.selectedBasis ? (Array.isArray(extra.selectedBasis) ? extra.selectedBasis.length + ' selected' : extra.selectedBasis) : null) || 'All'}}</td>
                            <td class="px-2 py-1.5">{{extra.upgradeCode || '-'}}</td>
                            <td class="px-2 py-1.5 text-center">{{extra.applyMarkup ? 'Yes' : 'No'}}</td>
                            <td class="px-2 py-1.5 text-center">{{extra.combinable ? 'Yes' : 'No'}}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }
                @if (getQuoteExtrasData(quote).length === 0 && quote.extrasLoadComplete) {
                  <div class="py-6 text-center text-gray-500 text-sm">No extras or specials for this quote</div>
                }
              </div>
            }
          </div>

          } @else {
          <div class="hidden sm:flex w-full min-w-[1500px] gap-4 px-2 sm:px-4 pb-2 text-xs font-semibold tracking-wide text-gray-500 uppercase border-b border-gray-200">
            <div class="w-32">Supplier</div>
            <div class="w-40 min-w-[160px]">Service</div>
            <div class="w-20">Meal plan</div>
            <div class="w-36">Dates</div>
            <div class="w-24 text-center">Gross Cost</div>
            <div class="w-20 text-center">Disc</div>
            <div class="w-24 text-center">Net Cost</div>
            <div class="w-16 text-center text-primary leading-tight roe-hint" matTooltip="ROE at quote creation (original rate)">
              <span class="block">Orginal</span>
              <span class="block">ROE</span>
            </div>
            <div class="w-24 text-center text-primary">Base Cost</div>
            <div class="w-20 text-center text-primary">Profit</div>
            <div class="w-24 text-center text-primary">Sell</div>
            <div class="w-16 text-center text-amber-500 leading-tight roe-hint" matTooltip="ROE as of today (current rate)">
              <span class="block">Todays</span>
              <span class="block">ROE</span>
            </div>
            <div class="w-24 text-center text-amber-500">Base Cost</div>
            <div class="w-20 text-center text-amber-500">Profit</div>
            <div class="w-24 text-center text-amber-500">Sell</div>
            <div class="w-24 text-center leading-tight">
              <span class="block">Cons.</span>
              <span class="block">Comm</span>
            </div>
            <div class="w-24 text-center leading-tight">
              <span class="block">Agent</span>
              <span class="block">Comm</span>
            </div>
            <div class="w-12 text-center">Action</div>
          </div>
          <ng-template #emptyCell>-</ng-template>
          @for (item of getServiceItems(quote); track $index) {
            <div class="relative flex cursor-pointer ml-2 sm:ml-4 mt-2" [ngClass]="{'bg-gray-100': $index % 2 === 1}">
              <div class="flex flex-col sm:flex-row sm:items-center w-full min-w-[1500px] gap-2 sm:gap-4 text-xs">
                @if (isReviewDrawerVisible) {
                  <div class="w-full sm:w-32 text-left min-w-0 overflow-visible">
                    <div>{{isAdjustmentItem(item) ? getAdjustmentSupplierLabel(item) : (item.supplier || '-')}}</div>
                    <span *ngIf="getProvidersLabel(item) as provider"
                          [matTooltip]="provider"
                          class="inline-flex mt-1 px-2 py-0.5 rounded-full text-[10px] font-semibold text-primary max-w-full truncate relative z-10">
                      {{provider}}
                    </span>
                    <span *ngIf="!isTransferItem(item) && getCodeLabel(item) as code"
                          [matTooltip]="code"
                          class="inline-flex mt-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-accent text-white max-w-full truncate relative z-10">
                      {{code}}
                    </span>
                  </div>
                  <div class="w-full sm:w-40 sm:min-w-[160px] text-left whitespace-normal break-words">
                    @if (isAdjustmentItem(item)) {
                      {{getAdjustmentServiceLabel(item)}}
                    }
                    @if (!isAdjustmentItem(item)) {
                      {{getServiceLabel(item) || '-'}}
                      <br/>
                      <span class="text-green-500" *ngIf="item.confirmationCode">{{item.confirmationCode}}</span>
                      @if (getBookingCode(item)) {
                      <br/><span class="text-blue-500 text-xs">Booking: {{getBookingCode(item)}}</span>
                      }
                      @if (isFlightItem(item) && getFareSource(item)) {
                      <br/>
                      <span class="text-hint text-xs">Fare source: {{getFareSource(item)}}</span>
                      }
                      @if (getItemValueAdds(item).length > 0) {
                      <div class="mt-1">
                        <div class="text-[11px] leading-4 text-gray-700 font-medium">Included:</div>
                        <ul class="mt-0.5 list-disc pl-4 space-y-0.5">
                        @for (valueAdd of getItemValueAdds(item); track valueAdd; let i = $index) {
                          <li class="text-[11px] leading-4 text-red-600 animate-pulse">
                            <span [innerHTML]="valueAdd"></span>
                            @if (getExtraCodeForValueAdd(item, valueAdd)) {
                              <span class="text-orange-600 font-medium"> ({{getExtraCodeForValueAdd(item, valueAdd)}})</span>
                            }
                          </li>
                        }
                        </ul>
                      </div>
                      }
                      @if (getItemDiscountReasons(item).length > 0) {
                      <div class="mt-1 space-y-0.5">
                        @for (reason of getItemDiscountReasons(item); track reason; let i = $index) {
                          <div class="text-[11px] leading-4 text-purple-600">
                            <span [innerHTML]="reason"></span>
                            @if (getDiscountOfferCode(item, reason)) {
                              <span class="font-medium"> ({{getDiscountOfferCode(item, reason)}})</span>
                            }
                          </div>
                        }
                      </div>
                      }
                    }
                  </div>
                  <div class="w-full sm:w-20 text-left">
                    <ng-container *ngIf="isAccommodationRow(item); else emptyCell">{{getMealPlanLabelForItem(item) || '-'}}</ng-container>
                  </div>
                  <div class="w-full sm:w-36">
                    <ng-container *ngIf="item.start && item.end; else emptyCell">
                      {{item.start | date : 'dd MMM yy'}} - {{item.end | date : 'dd MMM yy'}}
                    </ng-container>
                  </div>
                  <div class="w-full sm:w-24 text-left sm:text-center">
                    <ng-container *ngIf="item.cost != null; else emptyCell">
                      {{item.cost | currency:displayCurrencyCode:'symbol-narrow'}}
                    </ng-container>
                  </div>
                  <div class="w-full sm:w-20 text-left sm:text-center">
                    <ng-container *ngIf="item.costDiscount != null || item.discountTotals != null; else emptyCell">
                      {{(item.costDiscount != null ? item.costDiscount : item.discountTotals) | currency:displayCurrencyCode:'symbol-narrow'}}
                    </ng-container>
                  </div>
                  <div class="w-full sm:w-24 text-left sm:text-center">
                    <ng-container *ngIf="item.baseCostAfterDiscount != null || item.baseCostCurrentAfterDiscount != null || item.cost != null; else emptyCell">
                      {{(item.baseCostAfterDiscount != null ? item.baseCostAfterDiscount : (item.baseCostCurrentAfterDiscount != null ? item.baseCostCurrentAfterDiscount : item.cost)) | currency:displayCurrencyCode:'symbol-narrow'}}
                    </ng-container>
                  </div>
                  <div class="w-full sm:w-16 text-left sm:text-center text-primary">
                    {{(item.exchangeRate > 0 ? item.exchangeRate : 1) | number:'1.2-2'}}
                  </div>
                  <div class="w-full sm:w-24 text-left sm:text-center text-primary">
                    <ng-container *ngIf="showRoeCostDetails; else emptyCell">
                      <ng-container *ngIf="item.baseCostCurrentAfterDiscount != null || item.baseCostAfterDiscount != null || item.cost != null; else emptyCell">
                        {{(item.baseCostCurrentAfterDiscount != null ? item.baseCostCurrentAfterDiscount : (item.baseCostAfterDiscount != null ? item.baseCostAfterDiscount : item.cost)) | currency:displayCurrencyCode:'symbol-narrow'}}
                      </ng-container>
                    </ng-container>
                  </div>
                  <div class="w-full sm:w-20 text-left sm:text-center text-primary">
                    <ng-container *ngIf="showRoeCostDetails; else emptyCell">
                      <ng-container *ngIf="item.profit != null || item.profitCurrent != null; else emptyCell">
                        {{item.profit != null ? item.profit : item.profitCurrent}}
                      </ng-container>
                    </ng-container>
                  </div>
                  <div class="w-full sm:w-24 text-left sm:text-center text-primary">
                    <ng-container *ngIf="item.priceBeforeDiscount != null || item.priceCurrentBeforeDiscount != null || item.price != null; else emptyCell">
                      {{(item.priceBeforeDiscount != null ? item.priceBeforeDiscount : (item.priceCurrentBeforeDiscount != null ? item.priceCurrentBeforeDiscount : item.price)) | currency:displayCurrencyCode:'symbol-narrow'}}
                    </ng-container>
                  </div>
                  <div class="w-full sm:w-16 text-left sm:text-center text-amber-500">
                    {{(item.exchangeRateCurrent > 0 ? item.exchangeRateCurrent : (item.exchangeRate > 0 ? item.exchangeRate : 1)) | number:'1.2-2'}}
                  </div>
                  <div class="w-full sm:w-24 text-left sm:text-center text-amber-500">
                    <ng-container *ngIf="showRoeCostDetails; else emptyCell">
                      <ng-container *ngIf="item.baseCostCurrentAfterDiscount != null || item.baseCostAfterDiscount != null || item.cost != null; else emptyCell">
                        {{(item.baseCostCurrentAfterDiscount != null ? item.baseCostCurrentAfterDiscount : (item.baseCostAfterDiscount != null ? item.baseCostAfterDiscount : item.cost)) | currency:displayCurrencyCode:'symbol-narrow'}}
                      </ng-container>
                    </ng-container>
                  </div>
                  <div class="w-full sm:w-20 text-left sm:text-center text-amber-500">
                    <ng-container *ngIf="showRoeCostDetails; else emptyCell">
                      <ng-container *ngIf="item.profit != null || item.profitCurrent != null; else emptyCell">
                        {{item.profit != null ? item.profit : item.profitCurrent}}
                      </ng-container>
                    </ng-container>
                  </div>
                  <div class="w-full sm:w-24 text-left sm:text-center text-amber-500">
                    <ng-container *ngIf="item.priceBeforeDiscount != null || item.priceCurrentBeforeDiscount != null || item.price != null; else emptyCell">
                      {{(item.priceBeforeDiscount != null ? item.priceBeforeDiscount : (item.priceCurrentBeforeDiscount != null ? item.priceCurrentBeforeDiscount : item.price)) | currency:displayCurrencyCode:'symbol-narrow'}}
                    </ng-container>
                  </div>
                  <div class="w-full sm:w-24 text-left sm:text-center tabular-nums"></div>
                  <div class="w-full sm:w-24 text-left sm:text-center tabular-nums">
                    <ng-container *ngIf="item.commission != null || item.commissionCurrent != null || item.agentCommission != null || item.agentCommissionAmount != null; else emptyCell">
                      {{(item.commission != null ? item.commission : (item.commissionCurrent != null ? item.commissionCurrent : (item.agentCommission != null ? item.agentCommission : item.agentCommissionAmount))) | currency:displayCurrencyCode:'symbol-narrow'}}
                    </ng-container>
                  </div>
                  <div class="w-full sm:w-12 flex justify-center">
                    <button mat-icon-button [matMenuTriggerFor]="serviceItemMenu" class="hidden sm:inline-flex -mt-2" aria-label="Service item options">
                      <mat-icon class="icon-size-4" [svgIcon]="'heroicons_mini:ellipsis-vertical'"></mat-icon>
                    </button>
                    <mat-menu #serviceItemMenu="matMenu">
                      @if (isAccommodationRow(item)) {
                        <button mat-menu-item (click)="openEditMealPlanAndRoomType(quote, item)">
                          <span class="flex items-center">
                            <mat-icon class="icon-size-4 mr-3" [svgIcon]="'heroicons_solid:table-cells'"></mat-icon>
                            <span>Edit meal plan &amp; room type</span>
                          </span>
                        </button>
                        <div class="border-t border-gray-300"></div>
                      }
                      @if (LoggedInUser.agentType != 'AGENT') {
                        <button mat-menu-item (click)="openServiceItemDialog(item)">
                          <span class="flex items-center">
                            <mat-icon class="icon-size-4 mr-3" [svgIcon]="'heroicons_solid:pencil-square'"></mat-icon>
                            <span>CHANGE</span>
                          </span>
                        </button>
                        <button mat-menu-item (click)="openCommissionchangeDialog(item)">
                          <span class="flex items-center">
                            <mat-icon class="icon-size-4 mr-3" [svgIcon]="'heroicons_solid:currency-dollar'"></mat-icon>
                            <span>COMMISSIONS</span>
                          </span>
                        </button>
                        <button mat-menu-item (click)="openCaptureConfirmationDialog(item)">
                          <span class="flex items-center">
                            <mat-icon class="icon-size-4 mr-3" [svgIcon]="'heroicons_solid:document-check'"></mat-icon>
                            <span>CAPTURE CONFIRMATION</span>
                          </span>
                        </button>
                        <div class="border-t border-gray-300"></div>
                        <button mat-menu-item (click)="opencancelServiceItemDialog(item)">
                          <span class="flex items-center text-red-600">
                            <mat-icon class="icon-size-4 mr-3 text-red-500" [svgIcon]="'heroicons_solid:x-circle'"></mat-icon>
                            <span>CANCEL</span>
                          </span>
                        </button>
                      }
                      <div class="border-t border-gray-300"></div>
                      <button mat-menu-item (click)="openRemoveServiceItemDialog(item)">
                        <span class="flex items-center text-red-600">
                          <mat-icon class="icon-size-4 mr-3 text-red-500" [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                          <span>REMOVE</span>
                        </span>
                      </button>
                    </mat-menu>
                  </div>
                }
              </div>
            </div>
          }
          @if (getServiceTotals(quote); as totals) {
            <div class="flex w-full min-w-[1500px] gap-2 sm:gap-4 text-xs border-t border-gray-200 mt-3 pt-2 bg-sky-50">
              <div class="w-32 font-semibold text-left">Totals</div>
              <div class="w-40 min-w-[160px]"></div>
              <div class="w-20"></div>
              <div class="w-36"></div>
              <div class="w-24"></div>
              <div class="w-20"></div>
              <div class="w-24"></div>
              <div class="w-16"></div>
              <div class="w-24 text-center text-primary font-semibold">
                {{showRoeCostDetails ? (totals.baseCost | currency:displayCurrencyCode:'symbol-narrow') : '-'}}
              </div>
              <div class="w-20 text-center text-primary font-semibold">
                {{showRoeCostDetails ? (totals.profit | number:'1.2-2') : '-'}}
              </div>
              <div class="w-24 text-center text-primary font-semibold">{{totals.sell | currency:displayCurrencyCode:'symbol-narrow'}}</div>
              <div class="w-16"></div>
              <div class="w-24 text-center text-amber-500 font-semibold">
                {{showRoeCostDetails ? (totals.baseCost | currency:displayCurrencyCode:'symbol-narrow') : '-'}}
              </div>
              <div class="w-20 text-center text-amber-500 font-semibold">
                {{showRoeCostDetails ? (totals.profit | number:'1.2-2') : '-'}}
              </div>
              <div class="w-24 text-center text-amber-500 font-semibold">{{totals.sell | currency:displayCurrencyCode:'symbol-narrow'}}</div>
              <div class="w-24 text-center font-semibold tabular-nums">{{totals.consultantCommission | currency:displayCurrencyCode:'symbol-narrow'}}</div>
              <div class="w-24 text-center font-semibold tabular-nums">{{totals.agentCommission | currency:displayCurrencyCode:'symbol-narrow'}}</div>
              <div class="w-12"></div>
            </div>
          }

          <!-- Extras / Specials section (non-compact view) - supplier and room based -->
          <div class="border-t border-gray-200 mt-3 pt-3 hidden">
            <button type="button" class="flex items-center gap-2 w-full text-left py-2 px-2 rounded hover:bg-gray-50 font-medium text-sm" (click)="quote.showExtras = !quote.showExtras; loadQuoteExtras(quote)">
              <mat-icon class="icon-size-5">{{quote.showExtras ? 'expand_less' : 'expand_more'}}</mat-icon>
              Extras / Specials
              @if (quote.extrasLoaded && hasQuoteExtras(quote)) {
                <span class="bg-blue-100 text-blue-800 text-xs px-2 py-0.5 rounded-full">{{getQuoteExtrasCount(quote)}}</span>
              } @else if (quote.extrasLoadComplete) {
                <span class="text-gray-500 text-xs font-normal">No Extras</span>
              }
            </button>
            @if (false && quote.showExtras && quote.extrasLoaded !== undefined) {
              <div class="overflow-x-auto mt-2 border border-gray-200 rounded-lg">
                @for (supplierGroup of getQuoteExtrasData(quote); track supplierGroup.supplierName) {
                  <div class="p-3 border-b border-gray-100 last:border-b-0">
                    <div class="text-xs font-semibold text-gray-600 mb-2">{{supplierGroup.supplierName}}</div>
                    <table class="w-full text-xs min-w-[1800px]">
                      <thead>
                        <tr class="bg-gray-100">
                          <th class="px-2 py-1.5 text-left">From</th>
                          <th class="px-2 py-1.5 text-left">To</th>
                          <th class="px-2 py-1.5 text-left">Book By</th>
                          <th class="px-2 py-1.5 text-center">Min Stay</th>
                          <th class="px-2 py-1.5 text-center">Max Stay</th>
                          <th class="px-2 py-1.5 text-center">Start After</th>
                          <th class="px-2 py-1.5 text-center">Limit</th>
                          <th class="px-2 py-1.5 text-left">Description</th>
                          <th class="px-2 py-1.5 text-right">Cost Adult</th>
                          <th class="px-2 py-1.5 text-right">Cost Teen</th>
                          <th class="px-2 py-1.5 text-right">Cost Child</th>
                          <th class="px-2 py-1.5 text-right">Cost Infant</th>
                          <th class="px-2 py-1.5 text-center">Cost %</th>
                          <th class="px-2 py-1.5 text-center">Compulsory</th>
                          <th class="px-2 py-1.5 text-left">Rate Type</th>
                          <th class="px-2 py-1.5 text-left">Services</th>
                          <th class="px-2 py-1.5 text-left">Basis</th>
                          <th class="px-2 py-1.5 text-left">Code</th>
                          <th class="px-2 py-1.5 text-center">Apply Markup</th>
                          <th class="px-2 py-1.5 text-center">Combinable</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (extra of supplierGroup.extras; track $index) {
                          <tr class="border-t border-gray-100 hover:bg-gray-50">
                            <td class="px-2 py-1.5">{{extra.startDate | date:'dd MMM yy'}}</td>
                            <td class="px-2 py-1.5">{{extra.endDate | date:'dd MMM yy'}}</td>
                            <td class="px-2 py-1.5">{{extra.bookBy ? (extra.bookBy | date:'dd MMM yy') : '-'}}</td>
                            <td class="px-2 py-1.5 text-center">{{extra.minStay ?? '-'}}</td>
                            <td class="px-2 py-1.5 text-center">{{extra.maxStay ?? '-'}}</td>
                            <td class="px-2 py-1.5 text-center">{{extra.startAfter ?? '-'}}</td>
                            <td class="px-2 py-1.5 text-center">{{extra.limitTo ?? '-'}}</td>
                            <td class="px-2 py-1.5">{{extra.freeText || '-'}}</td>
                            <td class="px-2 py-1.5 text-right">{{(extra.cost ?? 0) | currency:displayCurrencyCode:'symbol-narrow'}}</td>
                            <td class="px-2 py-1.5 text-right">{{(extra.costTeen ?? extra.cost ?? 0) | currency:displayCurrencyCode:'symbol-narrow'}}</td>
                            <td class="px-2 py-1.5 text-right">{{(extra.costChild ?? extra.cost ?? 0) | currency:displayCurrencyCode:'symbol-narrow'}}</td>
                            <td class="px-2 py-1.5 text-right">{{(extra.costInfant ?? extra.cost ?? 0) | currency:displayCurrencyCode:'symbol-narrow'}}</td>
                            <td class="px-2 py-1.5 text-center">{{extra.costPercentage ?? '-'}}</td>
                            <td class="px-2 py-1.5 text-center">{{extra.compulsory ? 'Yes' : 'No'}}</td>
                            <td class="px-2 py-1.5">{{extra.rateType || '-'}}</td>
                            <td class="px-2 py-1.5">{{(extra.selectedServices?.length || extra.serviceIDs?.length) ? ((extra.selectedServices?.length || extra.serviceIDs?.length) + ' service(s)') : '-'}}</td>
                            <td class="px-2 py-1.5">{{extra.basisIDs || (extra.selectedBasis ? (Array.isArray(extra.selectedBasis) ? extra.selectedBasis.length + ' selected' : extra.selectedBasis) : null) || 'All'}}</td>
                            <td class="px-2 py-1.5">{{extra.upgradeCode || '-'}}</td>
                            <td class="px-2 py-1.5 text-center">{{extra.applyMarkup ? 'Yes' : 'No'}}</td>
                            <td class="px-2 py-1.5 text-center">{{extra.combinable ? 'Yes' : 'No'}}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }
                @if (getQuoteExtrasData(quote).length === 0 && quote.extrasLoadComplete) {
                  <div class="py-6 text-center text-gray-500 text-sm">No extras or specials for this quote</div>
                }
              </div>
            }
          </div>
          }
        </div>
      }
    </div>
  </ng-template>
  <ng-template #modalPaxDetails let-modal backdrop="static">
    <!-- LARGE MODAL -->
    <div class="modal-header">
      <h6 class="modal-title">
        Client Details <small>Capture your client details</small>
      </h6>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-sm-6 col-md-6">
          <div class="form-group">
            <label class="form-label">Name</label>
            <input type="text" class="form-control" placeholder="Name" value="John">
          </div>
        </div>
        <div class="col-sm-6 col-md-6">
          <div class="form-group">
            <label class="form-label">Surname</label>
            <input type="text" class="form-control" placeholder="Surname" value="Doe">
          </div>
        </div>
        <div class="col-sm-6 col-md-6">
          <div class="form-group">
            <label class="form-label">Email address <span class="text-danger">*</span></label>
            <input type="email" class="form-control" placeholder="Email Address" value="john.doe@example.com">
          </div>
        </div>
        <div class="col-sm-6 col-md-6">
          <div class="form-group">
            <label class="form-label">Tag</label>
            <select class="form-control">
              <option value="Tag1">Tag1</option>
              <option value="Tag2">Tag2</option>
              <option value="Tag3">Tag3</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3 col-md-3">
          <div class="form-group">
            <label class="form-label">Country Code</label>
            <input type="tel" class="form-control" placeholder="Country code" value="+27">
          </div>
        </div>
        <div class="col-sm-3 col-md-3">
          <div class="form-group">
            <label class="form-label">Area Code</label>
            <input type="tel" class="form-control" placeholder="Area code" value="011">
          </div>
        </div>
        <div class="col-sm-6 col-md-6">
          <div class="form-group">
            <label class="form-label">Phone Number</label>
            <input type="tel" class="form-control" placeholder="Telephone number" value="1234567">
          </div>
        </div>
      </div>
      <hr>
      <button type="button" class="btn-block toggle-button">
        <h6 class="toggle-text modal-title">Company Details <small>Capture your client's details</small></h6>
        <div class="switch">
          <input type="checkbox" style="display: none;">
          <label class="slider" ngbTooltip="Show/ Hide Company Details" placement="left"></label>
        </div>
      </button>
      <hr>
      <button type="button" class="btn-block toggle-button">
        <h6 class="toggle-text modal-title">Agent Details <small>Capture agent details</small></h6>
        <div class="switch">
          <input type="checkbox" style="display: none;">
          <label class="slider" ngbTooltip="Show/ Hide Agent Details" placement="left"></label>
        </div>
      </button>
      <div>
        <hr>
        <div class="row">
          <div class="col-sm-6 col-md-6">
            <div class="form-group">
              <label class="form-label">Name</label>
              <input type="text" class="form-control" placeholder="Company Name" value="Acme Corp">
            </div>
          </div>
          <div class="col-sm-6 col-md-6">
            <div class="form-group">
              <label class="form-label">Address</label>
              <input type="text" class="form-control" placeholder="Company Address" value="123 Main St">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label class="form-label">City</label>
              <input type="tel" class="form-control" placeholder="City" value="Johannesburg">
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label class="form-label">Code</label>
              <input type="tel" class="form-control" placeholder="Code" value="2000">
            </div>
          </div>
          <div class="col-sm-6 col-md-6">
            <div class="form-group">
              <label class="form-label">Country</label>
              <input type="tel" class="form-control" placeholder="Country" value="South Africa">
            </div>
          </div>
          <div class="col-sm-6 col-md-6">
            <div class="form-group">
              <label class="form-label">Registration Number</label>
              <input type="text" class="form-control" placeholder="Registration Number" value="123456789">
            </div>
          </div>
          <div class="col-sm-6 col-md-6">
            <div class="form-group">
              <label class="form-label">VAT Number</label>
              <input type="text" class="form-control" placeholder="VAT Number" value="987654321">
            </div>
          </div>
        </div>
      </div>
      <div>
        <hr>
        <div class="row">
          <div class="col-sm-6 col-md-6">
            <div class="form-group">
              <label class="form-label">Name</label>
              <input type="text" class="form-control" placeholder="Agent Name" value="Jane">
            </div>
          </div>
          <div class="col-sm-6 col-md-6">
            <div class="form-group">
              <label class="form-label">Surname</label>
              <input type="text" class="form-control" placeholder="Agent Surname" value="Smith">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-md-6">
            <div class="form-group">
              <label class="form-label">Email Address</label>
              <input type="tel" class="form-control" placeholder="Agent email" value="jane.smith@example.com">
            </div>
          </div>
          <div class="col-sm-6 col-md-6">
            <div class="form-group">
              <label class="form-label">Agency Name</label>
              <input type="tel" class="form-control" placeholder="Agency Name" value="Smith Agency">
            </div>
          </div>
          <div class="col-sm-6 col-md-6">
            <div class="form-group">
              <label class="form-label">Agency VAT Number</label>
              <input type="text" class="form-control" placeholder="VAT Number" value="123456789">
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-sm-12 col-md-12">
          <div class="form-group">
            <label class="form-label">Remarks</label>
            <textarea rows="5" class="form-control" placeholder="Booking remarks">Sample remarks</textarea>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-12 text-center">
          <small class="text-warning"><b>Please note</b><br />The itinerary will not be stored and/or searchable if no client details are captured.</small>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary">Update</button>
    </div>
  </ng-template>
  <ng-template #modalServiceFeeAdjustment let-modal>
    <!-- LARGE MODAL -->
    <div class="modal-header">
      <h6 class="modal-title">Service Fee / Adjustment <br /><small>Itinerary reference 12345</small></h6>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-sm-6 col-md-6">
          <div class="form-group">
            <label class="form-label">Type</label>
            <select class="form-control">
              <option value="Price Beat">Price Beat</option>
              <option value="Discount">Discount</option>
              <option value="Adjustment">Adjustment</option>
              <option value="Exchange rate change">Exchange rate change</option>
              <option value="other">Other</option>
            </select>
          </div>
        </div>
        <div class="col-sm-6 col-md-6">
          <div class="form-group">
            <label class="form-label">Amount <sup>in {{displayCurrencyCode}}</sup></label>
            <input type="number" class="form-control" placeholder="" value="500">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-12">
          <div class="form-group">
            <label class="form-label">Internal Note</label>
            <input type="text" class="form-control" placeholder="Enter note..." value="Sample internal note">
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="modal.dismiss()">Save</button>
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
    </div>
  </ng-template>
